module.exports = __webpack_public_path__ + "img/warehousing.15a3ea68.jpg";